import styled from 'styled-components'
import RaisedButton from 'components/RaisedButton/RaisedButton'

const skeletonAnimation = `
  @keyframes feedbackCardShimmer {
    0% {
      background-position: -280px 0;
    }
    100% {
      background-position: 280px 0;
    }
  }
`

export const Wrapper = styled.div`
  ${skeletonAnimation}
  display: flex;
  align-items: center;
  padding-left: 12px;

  gap: 12px;
`

/**
 * The feedback card keeps a 320px minimum width for short content,
 * then grows to match longer subtitle text instead of forcing the text to wrap.
 */
export const CardButton = styled(RaisedButton)`
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  transition:
    opacity 100ms ease,
    transform 100ms ease;
  height: 54px;
  min-width: 320px;
  padding-right: 10px;
  width: max-content;

  &.is-dismissing {
    opacity: 0;
    transform: translateY(-4px) scale(0.98);
    pointer-events: none;
  }

  &:hover .feedback-dismiss-button {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto;
  }
`

export const DismissButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 999px;
  background: #e53935;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transform: scale(0.92);
  pointer-events: none;
  transition:
    opacity 160ms ease,
    transform 160ms ease;
`

export const Icon = styled.img`
  width: 35px;
  height: 35px;
  object-fit: contain;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: 400;
`

export const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
`

export const SkeletonCircle = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: linear-gradient(90deg, #ececec 8%, #f7f7f7 18%, #ececec 33%);
  background-size: 560px 70px;
  animation: feedbackCardShimmer 1.1s infinite linear;
`

export const SkeletonLine = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  height: 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ececec 8%, #f7f7f7 18%, #ececec 33%);
  background-size: 560px 70px;
  animation: feedbackCardShimmer 1.1s infinite linear;
`
